import type { RunStatus, PostRemovalStatus } from "./useCompetitorLinkRemovalDetail";

// User-facing Russian vocabulary for the enum values surfaced on this screen
// (frontend-language rule). Kept in one place so the list and detail tables read
// identically (frontend.interface-copy: one vocabulary).
const RUN_STATUS_LABELS: Record<RunStatus, string> = {
  scanning: "Сканирование",
  awaiting_confirmation: "Ожидает подтверждения",
  removing: "Удаление",
  completed: "Завершён",
  cancelled: "Отменён",
};

const POST_REMOVAL_STATUS_LABELS: Record<PostRemovalStatus, string> = {
  pending: "Ожидает",
  removed: "Удалён",
  failed: "Ошибка",
  skipped: "Пропущен",
};

// Подпись режима автоудаления — таблица, а не ветвление: подпись здесь такие же
// данные, как и остальные подписи этого класса.
const AUTO_REMOVE_LABELS: Record<string, string> = { true: "Да", false: "Нет" };

export class CompetitorLinkRemovalLabels {
  public static runStatus(status: RunStatus): string {
    return RUN_STATUS_LABELS[status];
  }

  public static postRemovalStatus(status: PostRemovalStatus): string {
    return POST_REMOVAL_STATUS_LABELS[status];
  }

  public static autoRemove(autoRemove: boolean): string {
    return AUTO_REMOVE_LABELS[String(autoRemove)];
  }
}
